import React from 'react';

import styles from './Heading.module.scss';

type HeadingProps = {
  tag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'div' | 'p';
  level?: 1 | 2 | 3 | 4 | 5 | 6;
  children: React.ReactNode;
  className?: string;
};

const Heading: React.FC<HeadingProps> = ({ tag, level = 1, children, className = '' }) => {
  const Tag = tag ? tag : (`h${level}` as keyof JSX.IntrinsicElements);

  return <Tag className={`${styles[`h${level}`]} ${className}`}>{children}</Tag>;
};

export default Heading;
